import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
const WorkOrderStatusValues = [
  "READY_TO_ACCEPT",
  "ACCEPTED",
  "READY_TO_SCHEDULE",
  "HIC_SOLD_PENDING_SCHEDULING",
  "RESCHEDULED",
  "READY_FOR_REVIEW",
  "READY_FOR_PAYMENT",
  "COMPLETE",
  "REJECTED",
  "PAID",
  "CANCELED",
  "SCHEDULED",
  "APPROVED",
  "DECLINED",
  "OPEN",
  "REDESIGN_REQUESTED",
  "REDESIGN_IN_PROGRESS",
  "REDESIGN_REJECTED",
] as const;
/**
 * Use this if you need to zod parse it
 */
export const WorkOrderStatusSchema = z.enum(WorkOrderStatusValues);
/**
 * Use this if you need to use the literal value
 */
export const WorkOrderStatus = WorkOrderStatusSchema.enum;
/**
 * Use this if you need to use the type
 */
export type WorkOrderStatus = z.infer<typeof WorkOrderStatusSchema>;
/**
 * Use this if you need to display a human-readable name
 */
export const WorkOrderStatusDisplayNames: Record<WorkOrderStatus, string> = {
  READY_TO_ACCEPT: "Ready to Accept",
  ACCEPTED: "Accepted",
  READY_TO_SCHEDULE: "Ready to Schedule",
  HIC_SOLD_PENDING_SCHEDULING: "HIC Sold; Pending Scheduling",
  RESCHEDULED: "Rescheduled",
  READY_FOR_REVIEW: "Ready for Review",
  READY_FOR_PAYMENT: "Ready for Payment",
  COMPLETE: "Complete",
  REJECTED: "Rejected",
  PAID: "Paid",
  CANCELED: "Cancelled",
  SCHEDULED: "Scheduled",
  APPROVED: "Approved",
  DECLINED: "Declined",
  OPEN: "Open",
  REDESIGN_REQUESTED: "Redesign Requested",
  REDESIGN_IN_PROGRESS: "Redesign In Progress",
  REDESIGN_REJECTED: "Redesign Rejected",
} as const;

export const SunrunWorkOrderStatusValues = [
  "Ready to Accept",
  "Accepted",
  "Ready to Schedule",
  "HIC Sold; Pending Scheduling",
  "Scheduled",
  "Rescheduled",
  "Ready for Review",
  "Ready for Payment",
  "Complete",
  "Rejected",
  "Paid",
  "Cancelled",
  "Approved",
  "Declined",
  "Open",
  "Redesign Requested",
  "Redesign In Progress",
  "Redesign Rejected",
  "Customer Approved",
] as const;

export const SunrunWorkOrderStatusSchema = z.enum(SunrunWorkOrderStatusValues);
export type SunrunWorkOrderStatus = (typeof SunrunWorkOrderStatusValues)[number];
export const SunrunWorkOrderStatus = SunrunWorkOrderStatusSchema.enum;

export const SunrunWorkOrderStatusToRemiWorkOrderStatus: Record<SunrunWorkOrderStatus, WorkOrderStatus> = {
  "Ready to Accept": "READY_TO_ACCEPT",
  Accepted: "ACCEPTED",
  "Ready to Schedule": "READY_TO_SCHEDULE",
  "HIC Sold; Pending Scheduling": "HIC_SOLD_PENDING_SCHEDULING",
  Scheduled: "SCHEDULED",
  Rescheduled: "RESCHEDULED",
  "Ready for Review": "READY_FOR_REVIEW",
  "Ready for Payment": "READY_FOR_PAYMENT",
  Complete: "COMPLETE",
  Rejected: "REJECTED",
  Paid: "PAID",
  Cancelled: "CANCELED",
  Approved: "APPROVED",
  "Customer Approved": "COMPLETE",
  Declined: "DECLINED",
  Open: "OPEN",
  "Redesign Requested": "REDESIGN_REQUESTED",
  "Redesign In Progress": "REDESIGN_IN_PROGRESS",
  "Redesign Rejected": "REDESIGN_REJECTED",
} as const;
